module.exports = __webpack_public_path__ + "fonts/Roboto-BlackItalic.c470ca2b.ttf";